export default __webpack_public_path__ + "media/images/logo/sns/google-fff5178ed726208aaf8210b29400ab71.png";